import { redirect } from "react-router-dom";
import { withAuth } from "routes/utils/withAuth";

export const redirectToPickups = withAuth(async () => {
  return redirect("/pickups");
});
